var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dismiss_icon",
    "data-name": "Dismiss icon",
    transform: "translate(-431.5 -320)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 12,
    cy: 12,
    rx: 12,
    ry: 12,
    transform: "translate(431.5 320)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "close_1_",
    "data-name": "close (1)",
    transform: "translate(437.5 326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "close_1_2",
    "data-name": "close (1)",
    d: "M6.682,5.783l4.4-4.4A.732.732,0,0,0,10.045.35l-4.4,4.4L1.249.35A.732.732,0,0,0,.215,1.385l4.4,4.4-4.4,4.4a.732.732,0,1,0,1.035,1.035l4.4-4.4,4.4,4.4a.732.732,0,0,0,1.035-1.035Zm0,0",
    transform: "translate(0 -0.136)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.fbe61f31657ca228ec145bc5fbcddec6.svg";
export { ForwardRef as ReactComponent };